var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99968 15.1673H5.99968C2.37967 15.1673 0.833008 13.6207 0.833008 10.0007V6.00065C0.833008 2.38065 2.37967 0.833984 5.99968 0.833984H9.33301C9.60634 0.833984 9.83301 1.06065 9.83301 1.33398C9.83301 1.60732 9.60634 1.83398 9.33301 1.83398H5.99968C2.92634 1.83398 1.83301 2.92732 1.83301 6.00065V10.0007C1.83301 13.074 2.92634 14.1673 5.99968 14.1673H9.99968C13.073 14.1673 14.1663 13.074 14.1663 10.0007V6.66732C14.1663 6.39399 14.393 6.16732 14.6663 6.16732C14.9397 6.16732 15.1663 6.39399 15.1663 6.66732V10.0007C15.1663 13.6207 13.6197 15.1673 9.99968 15.1673Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 7.16633H11.9997C9.71967 7.16633 8.83301 6.27967 8.83301 3.99967V1.333C8.83301 1.133 8.95301 0.946334 9.13967 0.873C9.32634 0.793 9.53967 0.839667 9.68634 0.979667L15.0197 6.313C15.1597 6.453 15.2063 6.673 15.1263 6.85967C15.0463 7.04633 14.8663 7.16633 14.6663 7.16633ZM9.83301 2.53967V3.99967C9.83301 5.71967 10.2797 6.16633 11.9997 6.16633H13.4597L9.83301 2.53967Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 9.16602H4.66699C4.39366 9.16602 4.16699 8.93935 4.16699 8.66602C4.16699 8.39268 4.39366 8.16602 4.66699 8.16602H8.66699C8.94033 8.16602 9.16699 8.39268 9.16699 8.66602C9.16699 8.93935 8.94033 9.16602 8.66699 9.16602Z",
    fill: "#353535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 11.834H4.66699C4.39366 11.834 4.16699 11.6073 4.16699 11.334C4.16699 11.0607 4.39366 10.834 4.66699 10.834H7.33366C7.60699 10.834 7.83366 11.0607 7.83366 11.334C7.83366 11.6073 7.60699 11.834 7.33366 11.834Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedDoc);
export default __webpack_public_path__ + "static/media/uploadedDoc.6999c0010f8a8dbc457ea89b92ff267c.svg";
export { ForwardRef as ReactComponent };